import { PhosphorTrashButton } from "components/Atoms/PhosphorIconButton";
import React from "react";

interface Props {
  subject: server.dto.FavoriteSubject
  onEditClick: (subject: server.dto.FavoriteSubject) => void
  onDeleteClick: (subject: server.dto.FavoriteSubject) => void
}

const SubjectRowCard = (props: Props) => {
  const onDelete = () => { props.onDeleteClick(props.subject); };
  const onEdit = () => { props.onEditClick(props.subject); };
  return <div>
    <div className="grow1 table-main-link" onClick={onEdit}>
      {props.subject.subjectValue}
    </div>
    <PhosphorTrashButton
      layout="in-square"
      onClick={onDelete} />
  </div>;
};

export default SubjectRowCard;